import { render, staticRenderFns } from "./info.vue?vue&type=template&id=5a4dbc8b&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=5a4dbc8b&prod&lang=scss&"
import style1 from "./info.vue?vue&type=style&index=1&id=5a4dbc8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4dbc8b",
  null
  
)

export default component.exports